// extracted by mini-css-extract-plugin
export var container = "QueryNote-module--container--mVg4e";
export var textarea = "QueryNote-module--textarea--ZzHp5";
export var title = "QueryNote-module--title--BC5c6";